<template>
  <div class="wrapper">
    <v-card
      tile
      class="overflow-hidden no-scroll-bar"
      elevation="0"
      style="background-color: transparent;"
    >

      <v-app-bar
        class="app_bar"
        fixed
        color="primary"
        dark
        scroll-target="#scrolling-techniques-2"
      >
        <v-btn
          @click="toPrevMonth"
          icon
          class="no-background-hover"
          color="white"
          dark
        >
          <div class="d-flex align-center">
            <v-icon size="20" class="ml-4">mdi-chevron-left</v-icon>
            <h4 class="white--text">前の月</h4>
          </div>
        </v-btn>

        <v-spacer></v-spacer>

        <v-app-bar-title>
          <div @click="isCalendar = !isCalendar">
            <h5 class="text-center">
              {{ year }}年
            </h5>
            <div class="d-flex justify-center">
              <h3>{{ month }}</h3>
              <v-icon v-if="isCalendar">mdi-chevron-down</v-icon>
              <v-icon v-else>mdi-chevron-up</v-icon>
            </div>
          </div>
        </v-app-bar-title>

        <v-spacer></v-spacer>

        <v-btn
          @click="toNextMonth"
          icon
          class="no-background-hover"
          color="white"
        >
          <div class="d-flex align-center">
            <h4 class="white--text">次の月</h4>
            <v-icon size="20" class="mr-4">mdi-chevron-right</v-icon>
          </div>
        </v-btn>

      </v-app-bar>
      <v-expand-transition>
        <v-sheet
          class="mt-8"
          v-if="isCalendar"
          height="400"
          style="background-color: transparent;"
        >
          <v-calendar
            ref="event_calendar"
            :now="now"
            v-model="selectedDate"
            color="primary"
            locale="ja-jp"
            :day-format="timestamp => new Date(timestamp.date).getDate()"
            :month-format="timestamp => (new Date(timestamp.date).getMonth() + 1) + ' /'"
            @click:date="viewDay"
          >
            <template v-slot:day="{ date }">
              <div
                v-for="e in getEventNum(date)"
                :key="e.eventId"
                class="d-flex justify-center"
              >
                <div class="event_num ma-1"></div>
              </div>
            </template>
          </v-calendar>
        </v-sheet>
      </v-expand-transition>
      <div
        v-show="!isCalendar"
        class="pa-7"
      >
      </div>

      <v-sheet
        id="scrolling-techniques-2"
        class="overflow-y-auto no-scroll-bar"
        :style="{
          maxHeight: `calc(100vh - var(--app-top-offset) - 60px)`,
          backgroundColor: 'transparent'
        }"
        elevation="0"
      >
        <div
          v-scroll:#scrolling-techniques-2="onScroll"
          v-for="(e, index) in events"
          :key="e + index"
          class="plan-wrapper ma-1 pa-2 px-3 d-flex"
        >
          <div class="text-center pr-5" style="width: 40px;">
            <p class="caption">{{ dayFormat(e.date) }}</p>
            <h4 class="text-no-wrap">{{ dateFormat(e.date) }}</h4>
          </div>
          <div
            style="white-space:pre-wrap;user-select: none;"
          >
            <p style="line-height: 38px;">{{ e.eventName }}</p>
          </div>
          <v-spacer/>
          <div
            v-for="child in e.children"
            :key="child.childId"
          >
            <div class="icon mr-2">
              <img
                :src="child.imageUrl? child.imageUrl : 'https://via.placeholder.com/240x180?text=Sample+Image+1'"
              >
            </div>
          </div>
        </div>
      </v-sheet>

    </v-card>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');
import { when } from '@/service/Switch';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { VCalendar } from '@/model/Vuetify/VCalendar';

import { eventsModule } from '@/store/entityModules/events';
import { familyModule } from '@/store/entityModules/family';

import { ChildResponse } from '@API/src/component/home/family/types';
import {
  DefecationStatus,
  DefecationStatusType,
} from '../../node_modules/chaild-entity/src/component/home/defecation/types';

interface Event {
  name: string;
  date: string;
  start: Date;
  end: Date;
  color: string;
  timed: boolean;
  children: ChildResponse[];
}

interface DataType {
  selectedDate: string;
  selectedEvents: Event[];
  scrollInvoked: number;
  isCalendar: boolean;
  fetchLoading: boolean;
}

export default defineComponent({

  data: (): DataType =>({
    selectedDate: dayjs().format('YYYY-MM-DD'),
    selectedEvents: [],
    scrollInvoked: 0,
    isCalendar: true,
    fetchLoading: false,
  }),

  computed: {
    calendar(): VCalendar {
      return (this.$refs as any).event_calendar;
    },
    events() {
      return eventsModule.eventsIncludedDate;
    },
    children() {
      if (familyModule.family) {
        return familyModule.family.children;
      }
      return [];
    },
    now(): string {
      return dayjs(this.selectedDate).format('YYYY-MM-DD');
    },
    year(): string {
      return dayjs(this.selectedDate).format('YYYY');
    },
    month(): string {
      return dayjs(this.selectedDate).format('M月');
    },
    today(): string {
      return dayjs(this.selectedDate).format('M月D日');
    },
    dayOfTheWeek(): string {
      return dayjs(this.selectedDate).format('ddd');
    },
    dateFormatted(): string {
      return dayjs(this.selectedDate).format('YYYY年MM月DD日（ddd）');
    },
  },

  methods: {
    toNextMonth() {
      this.selectedDate = dayjs(this.selectedDate).add(1, 'month').startOf('month').format('YYYY-MM-DD');

      sessionStorage.setItem('calendarYearMonth', this.selectedDate);
      this.fetchEvents();
    },

    toPrevMonth() {
      this.selectedDate = dayjs(this.selectedDate).subtract(1, 'month').startOf('month').format('YYYY-MM-DD');

      sessionStorage.setItem('calendarYearMonth', this.selectedDate);
      this.fetchEvents();
    },
    viewDay({ date }: { date: string }) {
      this.selectedDate = date;
    },
    onScroll(e) {
      this.scrollInvoked = e.target.scrollTop;
      if (this.scrollInvoked > 0) {
        this.isCalendar = false;
      } else {
        this.isCalendar = true;
      }
    },
    minuteFormat(iso: string) {
      return dayjs(iso).format('HH:mm');
    },
    dateFormat(iso: string) {
      return dayjs(iso).format('D');
    },
    dayFormat(iso: string) {
      return dayjs(iso).format('ddd');
    },
    getDefecationState(state: DefecationStatusType): string {
      return when(state)
        .on((v) => v === DefecationStatus.hard, () => '硬い')
        .on((v) => v === DefecationStatus.normal, () => '普通')
        .on((v) => v === DefecationStatus.soft, () => '軟らかい')
        .on((v) => v === DefecationStatus.diarrhea, () => '水様便（下痢）')
        .otherwise(() => '');
    },
    async fetchEvents() {
      this.fetchLoading = true;
      const fromDate = dayjs(this.selectedDate).startOf('month');
      const endDate = dayjs(this.selectedDate).endOf('month');
      await eventsModule.fetchEvents({
        childId: null,
        from: dayjs(fromDate).format('YYYY-MM-DD'),
        to: dayjs(endDate).format('YYYY-MM-DD'),
      });
      this.fetchLoading = false;
    },
    showEvent({ nativeEvent, event }) {
      this.selectedEvents.push(event);
    },
    formatSelectedEvents(): string[] {
      const events: string[] = [];
      if (this.selectedEvents.length) {
        this.selectedDate = dayjs(this.selectedEvents[0].start).format('YYYY-MM-DD');
        for (const s of this.selectedEvents) {
          if (
            dayjs(s.start).format('hh:mm') === '12:00' &&
            dayjs(s.end).format('hh:mm') === '12:00'
          ) {
            events.push(`${s.name}`);
          } else if (s.start && s.end) {
            const from = dayjs(s.start).format('hh:mm');
            const to = dayjs(s.end).format('hh:mm');
            events.push(`${from}-${to} ${s.name}`);
          }
        }
        return events;
      }
      return [];
    },
    getEventNum(date: string) {
      const arr = this.events.filter((e) => {
        if (e.date === date) { return e; }
      });
      return arr;
    },
  },

  async mounted() {
    const calendarYearMonth = sessionStorage.getItem('calendarYearMonth');
    if (calendarYearMonth) this.selectedDate = calendarYearMonth;
    this.fetchEvents();

  },
});
</script>
<style lang="scss" scoped>
@use '../sass/ress.scss';

.wrapper {
  height: 100%;
  overflow-y: scroll;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;

  .app_bar {
    @supports (bottom: env(safe-area-inset-bottom)) {
      padding-top: env(safe-area-inset-top);
    }
  }

  .plan-wrapper {
    min-height: 58px;
    border: 1px solid rgb(var(--v-theme-success));
    border-radius: 5px 5px;
  }

  .icon {
    height: 40px;
    width: 40px;

    img {
      height: 100%;
      width: 100%;
      border-radius: 100%;
      object-fit: cover;
    }
  }

  .event_num {
    height: 8px;
    width: 8px;
    background-color: rgb(var(--v-theme-primary));
    border-radius: 100%;
  }
}
</style>
